import { gql } from '@apollo/client';

export const updateUser = gql`
  mutation editUser(
    $id: ID!
    $isDevTeam: Boolean
    $name: String!
    $active: Boolean
    $mailStop: String
    $emailAddress: String
    $sendEmail: Boolean
    $applicationUserRoles: [ApplicationUserRoleInput!]!
  ) {
    updateUser(
      user: {
        id: $id
        name: $name
        active: $active
        mailStop: $mailStop
        isDevTeam: $isDevTeam
        sendEmail: $sendEmail
        emailAddress: $emailAddress
        applicationUserRoles: $applicationUserRoles
      }
    )
  }
`;

export const getUser = (id) => gql`
{
  readOneApplicationUser(id : ${id}){
    id
    name
    adId
    sendEmail
    isDevTeam
	  active
    mailStop
    emailAddress
    applicationUserRoles{
      isDefaultRole
      department{
        id
        Name
      }
      role {
        id
        roleType
      }
    }
  }
}
`;

export const deleteUser = gql`
  mutation deleteUser($id: Float!) {
    deleteUser(id: $id)
  }
`;
